import { createContext, useContext, useState, useCallback } from "react";
import { t as translate } from "../lib/i18n";

const LangCtx = createContext(null);

export function LangProvider({ children }) {
    const [lang, setLang] = useState(() => localStorage.getItem("wmf_lang") || "en");
    const switchLang = useCallback((l) => {
        localStorage.setItem("wmf_lang", l);
        setLang(l);
    }, []);
    const t = useCallback((k) => translate(lang, k), [lang]);
    return <LangCtx.Provider value={{ lang, setLang: switchLang, t }}>{children}</LangCtx.Provider>;
}

export function useLang() {
    return useContext(LangCtx);
}
